import { render } from "./CustomizedTemplate.vue?vue&type=template&id=7bd43202"
import script from "./CustomizedTemplate.vue?vue&type=script&lang=js"
export * from "./CustomizedTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script